import { configureIguazuRPC, setProcedures } from 'iguazu-rpc';
import readUserSession from '@americanexpress/iguazu-procedures/readUserSessionV1';
import { readCustomerProductsV2, readCustomerProductDetailsV1 } from '@americanexpress/product-ducks';

import readCustomerProducts from './products';
import readCustomerProductDetails from './productz';

const configureIguazuProcedures = () => {
  configureIguazuRPC({
    getToState: (state) => state.getIn(['modules', 'axp-card-member-apply-root', 'procedures']),
  });
  setProcedures({
    // ... place your procedure imports here
    readUserSession,
    readCustomerProductDetails,
    readCustomerProducts,
    readCustomerProductsV2,
    readCustomerProductDetailsV1,
  });
};

configureIguazuProcedures();

export default configureIguazuProcedures;
